import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {MedicalPainFindAllService} from '../../../impl/service/medicalPainFindAll.service';
import {SelectFilterElement} from '../../../../../../../components/common/select-filter/select-filter.model';
import {MedicalRecordPainModel} from '../../model/medicalRecordPain.model';
import {Operator, UrlParameter} from '../../../../../../../shared/utils/url.builder';
import {NewItemModalOptions} from '../../../../../../core/component/select/abstract-select.component';
import {
    MedicalRecordPainCreateUpdateComponent,
    MedicalRecordPainSaveDialogInput,
    MedicalRecordPainSaveDialogResult
} from '../medical-record-pain-create-update/medical-record-pain-create-update.component';
import {ConsultationSummaryModel} from '../../../../../consultation/consultation/api/model/consultationSummary.model';

@Component({
    selector: 'app-medical-record-pain-multiple-select-filter',
    templateUrl: './medical-record-pain-multiple-select-filter.component.html',
    viewProviders: [MedicalPainFindAllService]
})
export class MedicalRecordPainMultipleSelectFilterComponent implements OnInit, OnChanges {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() noEntriesFoundLabel = 'Aucune douleur trouvée';
    @Input() parentFormControlName: string;
    @Input() partnerId: number;
    @Input() consultationSummary: ConsultationSummaryModel;

    additionalUrlParameters: UrlParameter[] = [];

    constructor(public service: MedicalPainFindAllService) {
    }

    ngOnInit() {
    }

    resolveSelectFilterElement = (entity: MedicalRecordPainModel): SelectFilterElement<string | number, MedicalRecordPainModel> => {
        return new SelectFilterElement(entity.id, entity.id, entity);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['partnerId']) {
            this.additionalUrlParameters = [new UrlParameter('partner.id', this.partnerId, Operator.EQUALS)];
        }
    }

    filter = (criteria: string, entity: MedicalRecordPainModel) => {
        return entity.toString().toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    newPainModalOptions(): NewItemModalOptions<MedicalRecordPainSaveDialogResult,
        MedicalRecordPainSaveDialogInput,
        MedicalRecordPainCreateUpdateComponent> {
        const input: MedicalRecordPainSaveDialogInput = {
            partnerId: this.consultationSummary ? undefined : this.partnerId,
            consultationSummary: this.consultationSummary,
            startTranscription: false,
        };
        const options =  {
            componentType: MedicalRecordPainCreateUpdateComponent,
            dialogOption: {
                title: 'Nouvelle douleur'
            },
            dialogInput: input,
            valueNewItemMapper: this.valueNewItemMapper
        };
        return options;
    }

    valueNewItemMapper = (newValue: MedicalRecordPainSaveDialogResult) => {
        return newValue?.entity?.id;
    }
}
